module.exports = __webpack_public_path__ + "media/images/logo-06bd79d30a4c494daaba278b2cede538.svg";